module.exports = __webpack_public_path__ + "static/media/sq-stuff-envelope.9ba10e36.mp4";